<form [formGroup]="radioGroup">
  <div class="d-flex flex-column h-100">
    <label class="label-preview-title">{{item.templateOptions.label}} @if (item.templateOptions.required) {
      <span>*</span>
    }</label>
    <div class="d-flex align-items-start mt-2 flex-wrap" style="height: 100%; overflow-y: scroll;">
      <div class="form-check w-100 text-start">
        <div class="row">
          @for (option of item.templateOptions.options; track option; let i = $index) {
            <div [ngClass]="{'col-md-6': item.templateOptions.options.length > 2, 'col-md-12': item.templateOptions.options.length <= 2}">
              <div class="custom-control ps-0 custom-radio" (click)="changeRadioCheck(option)">
                <input
                  type="radio"
                  class="form-check-input ms-0"
                  [value]="option.value"
                  formControlName="selection"
                  [id]="'input-'+item.key+option.value"/>
                <label class="form-check-label label-form" [for]="'input-'+item.key+option.value">{{ option.label }}</label>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
    @if (radioControl.invalid && radioControl.errors['required'] && radioControl.touched) {
      <p class="validation-text pb-0 text-start">{{ 'MAIN.CONTENT.WORKFLOW.REQUIRED' | translate }}</p>
    }
  </div>
</form>